import React, { createRef } from "react";
import { connect } from "react-redux";
import Menu from "../menu";
import { Table, Pagination, Button, DatePicker } from "../../components";
import { axios, Globals } from "../../utils";
import PrinterIcon from '../../assets/icons/printer.png';
import moment from "moment";

class SalesBook extends React.Component {

  state = {
    header: [
      'Fecha',
      'Concepto',
      'RIF',
      'Nombre o\nrazón social',
      'N° de\nfactura',
      'N° de\ncontrol',
      'Factura\nafectada',
      'Total ventas\n+ IVA',
      'Ventas\nexentas',
      'Base imponible\nalicuota general',
      'IVA %',
      'IVA\nAlicuota\ngeneral',
      'Impuesto\nretenido 75%',
      'Impuesto\nretenido 100%'
    ],
    form: {
      user_id: this.props.user.id,
      since: "",
      until: "",
    },
    page: 1,
    last_page: 1,
    data: [],
    dates: {
      minDate: "",
      maxDate: ""
    },
  };

  abortController = new AbortController();
  debounce = createRef();

  componentDidMount() {
    this.load();
  }

  componentWillUnmount() {
    this.abortController.abort();
  }

  load = async (page = 1) => {
    Globals.setLoading();

    try {
      const filter = {
        ...this.state.form,
        page,
        since: this.state.form.since ? moment(this.state.form.since).format('YYYY-MM-DD') : null,
        until: this.state.form.until ? moment(this.state.form.until).format('YYYY-MM-DD') : null,
      };

      const res = await axios.post("admin/orders/salesbook?page=" + page, filter);
      this.setState({
        page,
        last_page: res.data.data.last_page,
        data: res.data.data.data
      });

    } catch (error) {
      console.log(error);
    }

    Globals.quitLoading();
  };

  change = async(value, target) => {
    await this.setState(s => ({ form: { ...s.form, [target]: value } }));
    this.load();
  };

  returnState = async () => {
    await this.setState(state => ({
      ...state,
      form: {
        user_id: this.props.user.id,
        since: "",
        until: "",
      },
    }));
    await this.load();
  };

  print = async () => {
    let { form } = Globals.copy(this.state);
    form.download = true;

    Globals.setLoading();
    try {
      const res = await axios.post('admin/orders/salesbook', form);
      if (res.data.url) {
        const win = window.open(res.data.url, "_blank");
        win.focus();

      } else {
        Globals.showError('Ha ocurrido un error');
      }

    } catch (error) {
      console.log(error);
    }
    Globals.quitLoading();
  };

  render() {
    return (
      <Menu history={this.props.history}>
        <div className="row">
          <div className="col-md-2">
            <DatePicker
              color="white"
              label="Desde"
              className="filter"
              minDate={this.state.dates.minDate}
              value={this.state.form.since}
              onChange={value => this.change(value, 'since')}
            />
          </div>
          <div className="col-md-2">
            <DatePicker
              color="white"
              label="Hasta"
              className="filter"
              maxDate={this.state.dates.maxDate}
              value={this.state.form.until}
              onChange={value => this.change(value, 'until')}
            />
          </div>
          <div className="col-md-3">
            <div className="container-buttons" style={{ display: 'flex', gap: '1rem' }}>
              <Button className="btn-align-bottom btn-filter blue" color=" " onClick={() => this.load()}>
                <span>Filtrar</span>
              </Button>
              <Button className="btn-align-bottom btn-filter" color=" " onClick={this.returnState}>
                <span>Limpiar</span>
              </Button>
            </div>
          </div>
        </div>

        <Table
          data={this.state.data.length}
          title="Registro de libro de ventas"
          header={this.state.header}
          right={
            <Button title="Imprimir" small="true" onClick={this.print}>
              <img src={PrinterIcon} alt="Imprimir" />
            </Button>
          }
        >
          {this.state.data.map((i, index) => {
            return (
              <tr key={index}>
                <td>{ i.date }</td>
                <td>{ i.type }</td>
                <td>{ i.rif }</td>
                <td>{ i.name }</td>
                <td>{ i.bill_number ?? '' }</td>
                <td>{ i.correlative_number }</td>
                <td></td>
                <td align="right">{ Globals.formatMiles(Number(i.total_bs)) }</td>
                <td align="right">{ Globals.formatMiles(Number(i.exentas_general_bs)) }</td>
                <td align="right">{ Globals.formatMiles(Number(i.base_imponible_alicuota_general_bs)) }</td>
                <td>{ i.iva }</td>
                <td align="right">{ Globals.formatMiles(Number(i.iva_alicuota_bs)) }</td>
                <td align="right">{ Globals.formatMiles(Number(i.retenidos_75)) }</td>
                <td align="right">{ Globals.formatMiles(Number(i.retenidos_100)) }</td>
              </tr>
            );
          })}
        </Table>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={page => this.load(page)}
        />
      </Menu>
    );
  }
}

export default connect(state => {
  return {
    user: state.user
  };
})(SalesBook);
